import { useLocation } from '@reach/router';
import GridViewIcon from '@src/assets/icons/grid-view.svg';
import ListViewIcon from '@src/assets/icons/list-view.svg';
import SuitcaseIcon from '@src/assets/icons/suitcase.svg';
import BackgroundImage from '@src/components/BackgroundImage';
import FieldWithLabel from '@src/components/FieldWithLabel';
import TeacherCard from '@src/components/teacherCard';
import { useUser } from '@src/services/userContext';
import api from '@src/utils/api.js';
import {
  convertToPercentage,
  currencyToSymbol,
  getSiteCurrency,
} from '@src/utils/pricing';
import { getCachedScrollPosition } from '@src/utils/scroll';
import { Themed } from '@theme-ui/mdx';
import { startOfDay } from 'date-fns';
import lt from 'date-fns/locale/lt';
import { navigate } from 'gatsby';
import { getImage } from 'gatsby-plugin-image';
import debounce from 'lodash.debounce';
import React, { useEffect, useRef, useState } from 'react';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Loader } from 'semantic-ui-react';
import { Box, Button, Container, Flex, Grid } from 'theme-ui';
// TODO: rename and refactor this banana code
registerLocale('lt', lt);

const PAGE_SIZE = 12;
const roles = {
  teacher: 2,
  student: 3,
  parent: 4,
};
export const loadData = async (
  subject,
  {
    priceFrom,
    priceTo,
    order,
    q,
    orderDirection,
    startDateTime,
    endDateTime,
    page = 1,
  } = {},
  limit = PAGE_SIZE,
  studentId
) => {
  let data = null;
  let pagination = null;

  try {
    const params = {
      priceFrom,
      priceTo,
      order,
      q,
      orderDirection,
      startDateTime,
      endDateTime,
      limit,
      page,
      currency: getSiteCurrency(),
    };
    Object.keys(params).forEach((key) => !params[key] && delete params[key]);
    if (params.startDateTime) {
      params.startDateTime = Date.parse(params.startDateTime);
    }
    if (params.endDateTime) {
      params.endDateTime = Date.parse(params.endDateTime);
    }
    if (studentId) {
      params.studentId = studentId;
    }
    const res = await api.get(
      'teachers?' + new URLSearchParams({ ...params, subject })
    );
    data = res.data;
    pagination = res.pagination;
  } catch (error) {
    console.log(error);
  }

  const descriptionLength = 160;
  const allTeachers = data
    ? data.map((teacher) => {
        return {
          id: teacher.userId,
          slug: teacher.tag,
          firstName: teacher.firstName,
          description:
            teacher.description.length > descriptionLength
              ? teacher.description.slice(0, descriptionLength) + '...'
              : teacher.description.slice(0, descriptionLength),
          avatarUrl: teacher.avatarUrl,
          videoUrl: teacher.videoUrl,
          // subject: teacher.subject,
          price: `${(Math.round(teacher.lessonprice * 100) / 100).toFixed(2)} ${
            currencyToSymbol[teacher.currency]
          }`,
          priceNumber: (Math.round(teacher.lessonprice * 100) / 100).toFixed(2),
          rating: convertToPercentage(teacher.rating, 5),
          ratingCount: teacher.ratingCount,
          isFeatured: teacher.isFeatured,
          currency: currencyToSymbol[teacher.currency],
          available_slots: teacher.available_slots,
          isPublishedAndCalendarEmpty: teacher.isPublishedAndCalendarEmpty,
          lessonCount: teacher.lessonCount,
        };
      })
    : [];
  const viewTeachers = allTeachers.filter(
    (teacher) => !teacher.isPublishedAndCalendarEmpty
  );
  const viewPagination = {
    total: pagination ? `(${pagination.total})` : {},
    lastPage: pagination?.lastPage,
  };

  return {
    viewTeachers: viewTeachers,
    viewPagination: viewPagination,
  };
};
const updateSearchParams = async (params, replace = false) => {
  const searchParams = new URLSearchParams(window.location.search);
  for (const [key, value] of Object.entries(params)) {
    if (value) {
      if (key === 'startDateTime' || key === 'endDateTime') {
        searchParams.set(key, Date.parse(value));
      } else {
        searchParams.set(key, value);
      }
    } else {
      searchParams.delete(key);
    }
  }
  if (searchParams.toString().length) {
    // if (replace) {
    //   history.replaceState(params, "", window.location.pathname + '?' + searchParams.toString());
    // } else {
    //   history.pushState(params, "", window.location.pathname + '?' + searchParams.toString());
    // }

    await navigate(`?${searchParams.toString()}`, { state: params, replace });
  }
};

const subjectSearchPage = ({ data, locale }) => {
  const pageData = data.contentfulMokomojoDalykoMokytojuPuslapis;
  const subjectApiId = pageData.subject.uniqueId;
  const image = getImage(pageData.subject.image);
  const winLocation = useLocation();
  // refs and hooks
  const resultsRef = useRef(null);
  const { t } = useTranslation();
  // data
  const [total, setTotal] = useState(null);
  const [results, setResults] = useState([]);
  // fitlers state
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [filters, setFiters] = useState({
    priceFrom: '',
    priceTo: '',
    order: null,
    orderDirection: null,
    startDateTime: null,
    endDateTime: null,
    page: null,
    q: null,
  });

  // ui actions
  const [isListMode, setIsListMode] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [q, setQ] = useState();
  const [priceFrom, setPriceFrom] = useState();
  const [priceTo, setPriceTo] = useState();
  const [filtersChanged, setFiltersChanged] = useState(false);
  const user = useUser();

  const sortOptions = [
    {
      label: t('sortAvailableDesc'),
      orderDirection: 'desc',
      order: 'availability',
    },
    { label: t('sortPriceAsc'), orderDirection: 'asc', order: 'price' },
    { label: t('sortPriceDesc'), orderDirection: 'desc', order: 'price' },
    { label: t('sortRatingDesc'), orderDirection: 'desc', order: 'rating' },
  ];
  // TODO: laikinas sprendimas, kol nebus išspręstas klausimas su perasimu
  const getInitialsParams = () => {
    const searchParams = new URLSearchParams(winLocation.search);
    const order = searchParams.get('order');
    const orderDirection = searchParams.get('orderDirection');
    const page = searchParams.get('page');
    const query = searchParams.get('q');
    const priceFrom = searchParams.get('priceFrom');
    const priceTo = searchParams.get('priceTo');
    const endDateTime = searchParams.get('endDateTime');
    const startDateTime = searchParams.get('startDateTime');
    const initialParams = {};

    if (order && ['price', 'rating'].includes(order)) {
      initialParams['order'] = order;
    }
    if (query) {
      initialParams['q'] = query;
    }

    if (orderDirection && ['asc', 'desc'].includes(orderDirection)) {
      initialParams['orderDirection'] = orderDirection;
    }

    if (page) {
      const pageNumber = Number(page);
      if (!isNaN(pageNumber)) {
        initialParams['page'] = pageNumber;
      }
    }

    if (priceFrom) {
      initialParams['priceFrom'] = priceFrom;
    }

    if (priceTo) {
      initialParams['priceTo'] = priceTo;
    }

    if (endDateTime) {
      initialParams['endDateTime'] = endDateTime;
    }

    if (startDateTime) {
      initialParams['startDateTime'] = startDateTime;
    }

    return initialParams;
  };

  const scrollToInitialPage = (page) => {
    const children = Array.from(resultsRef.current.children);
    const itemIndex = (page - 1) * PAGE_SIZE;

    if (itemIndex < children.length) {
      children[itemIndex].scrollIntoView();
    }
  };
  const restoreState = async () => {
    const state = window.history.state;
    if (state) {
      setIsFetching(true);

      const {
        priceFrom,
        priceTo,
        order,
        orderDirection,
        startDateTime,
        endDateTime,
        page,
        q,
      } = state;
      const newFilters = {
        priceFrom: priceFrom || '',
        priceTo: priceTo || '',
        order: order || null,
        orderDirection: orderDirection || null,
        startDateTime: startDateTime ? new Date(startDateTime) : null,
        endDateTime: endDateTime ? new Date(endDateTime) : null,
        page: page || null,
        q: q || '',
      };
      setFiters(newFilters);
      const { viewTeachers, viewPagination } = await loadData(
        subjectApiId,
        newFilters,
        PAGE_SIZE,
        user?.role === roles.student ? user.id : null
      );
      if (newFilters.page) {
        setCurrentPage(newFilters.page);
      }
      updateSearchParams({ ...newFilters }, true);
      setResults(viewTeachers);
      setTotal(viewPagination.total);
      setHasMore(parseInt(viewPagination.lastPage) > 1);
      setIsFetching(false);
    }
  };

  useEffect(() => {
    window.onpopstate = restoreState;
    const scrollPosition = getCachedScrollPosition(location, history);

    const load = async () => {
      setIsFetching(true);
      const intiParams = history?.state?.hasOwnProperty('page')
        ? history.state
        : getInitialsParams();
      delete intiParams.key;
      setFiters({
        priceFrom: intiParams.priceFrom || '',
        priceTo: intiParams.priceTo || '',
        order: intiParams.order || null,
        orderDirection: intiParams.orderDirection || null,
        startDateTime: intiParams.startDateTime || null,
        endDateTime: intiParams.endDateTime || null,
        q: intiParams.q || null,
      });
      setQ(intiParams.q);
      setPriceFrom(intiParams.priceFrom);
      setPriceTo(intiParams.priceTo);
      const { page, ...otherParams } = intiParams;
      if (parseInt(page) > 1) {
        const responsee = await Promise.all(
          new Array(page).fill(0).map(async (item, index) => {
            const { viewTeachers, viewPagination } = await loadData(
              subjectApiId,
              { ...otherParams, page: index + 1 },
              PAGE_SIZE,
              user?.role === roles.student ? user.id : null
            );
            return [viewTeachers, viewPagination];
          })
        );
        const viewTeachers = responsee.map((item) => item[0]).flat();
        const viewPagination = responsee[responsee.length - 1][1];
        if (intiParams.page) {
          setCurrentPage(intiParams.page);
        }
        updateSearchParams({ ...otherParams, page }, true);
        setResults(viewTeachers);
        setTotal(viewPagination.total);
        setHasMore(parseInt(viewPagination.lastPage) > 1);
        setIsFetching(false);
      } else {
        const { viewTeachers, viewPagination } = await loadData(
          subjectApiId,
          { ...otherParams },
          PAGE_SIZE,
          user?.role === roles.student ? user.id : null
        );
        updateSearchParams({ ...otherParams, page }, true);
        setResults(viewTeachers);
        setTotal(viewPagination.total);
        setHasMore(parseInt(viewPagination.lastPage) > 1);
        setIsFetching(false);
      }

      setTimeout(() => {
        if (page && !scrollPosition) {
          scrollToInitialPage(page);
        } else if (scrollPosition) {
          setTimeout(() => {
            window.scrollTo(0, scrollPosition);
          }, 0);
        }
      }, 0);
    };
    load();

    setDefaultLocale(locale);
    return () => (window.onpopstate = null);
  }, []);

  function handleEndDateChange(date) {
    if (date) {
      const parsed = startOfDay(date);
      if (filters.startDateTime > parsed) {
        setStartDate(parsed);
        setFiters({ ...filters, endDateTime: parsed, startDateTime: parsed });
      } else {
        setFiters({ ...filters, endDateTime: parsed });
      }
    }
    setFiltersChanged(true);
  }
  function handleStartDateChange(date) {
    if (date) {
      const parsed = startOfDay(date);
      if (parsed >= filters.endDateTime || filters.endDateTime == null) {
        setFiters({ ...filters, endDateTime: parsed, startDateTime: parsed });
      } else {
        setFiters({ ...filters, startDateTime: parsed });
      }
    } else {
      const parsed = startOfDay(startOfDay(Date.now()));
      if (filters.startDateTime > parsed || !filters.startDateTime) {
        setFiters({ ...filters, endDateTime: parsed, startDateTime: parsed });
      } else {
        setFiters({ ...filters, startDateTime: parsed });
      }
    }
    setFiltersChanged(true);
  }

  const submitFilters = async (e) => {
    if (e) {
      e.preventDefault();
    }
    setIsFetching(true);
    const newFilters = { ...filters, page: 1 };
    setFiters(newFilters);
    const { viewTeachers, viewPagination } = await loadData(
      subjectApiId,
      newFilters,
      PAGE_SIZE,
      user?.role === roles.student ? user.id : null
    );
    setCurrentPage(1);
    setResults(viewTeachers);
    setHasMore(parseInt(viewPagination.lastPage) > 1);
    setTotal(viewPagination.total);
    setIsFetching(false);
    setFiltersChanged(false);
    await updateSearchParams(newFilters, false);
  };
  const onSearchBoxChange = (e) => {
    const newFilters = { ...filters, [e.target.id]: e.target.value };
    setFiters(newFilters);
    setFiltersChanged(true);
  };
  useEffect(() => {
    if (filtersChanged) {
      submitFilters();
    }
  }, [filtersChanged]);

  const updateSearchInput = (e) => onSearchBoxChange(e);
  const handleInputChange = debounce(updateSearchInput, 1000);
  const handleSort = async (e) => {
    const selectedSort = sortOptions[e.target.value];
    const newFilters = {
      ...filters,
      page: 1,
      order: selectedSort.order,
      orderDirection: selectedSort.orderDirection,
    };
    setFiters({
      ...filters,
      page: 1,
      order: selectedSort.order,
      orderDirection: selectedSort.orderDirection,
    });
    setIsFetching(true);
    const { viewTeachers, viewPagination } = await loadData(
      subjectApiId,
      newFilters,
      PAGE_SIZE,
      user?.role === roles.student ? user.id : null
    );
    setResults(viewTeachers);
    setHasMore(parseInt(viewPagination.lastPage) > 1);
    setTotal(viewPagination.total);
    await updateSearchParams(newFilters, false);
    setIsFetching(false);
  };

  const loadMoreData = async () => {
    const newParams = {
      ...filters,
      page: currentPage + 1,
    };
    const { viewTeachers, viewPagination } = await loadData(
      subjectApiId,
      newParams,
      PAGE_SIZE,
      user?.role === roles.student ? user.id : null
    );
    setHasMore(parseInt(viewPagination.lastPage) > currentPage + 1);
    setCurrentPage(currentPage + 1);
    setResults((oldValues) => {
      return oldValues.concat(viewTeachers);
    });
    setTotal(viewPagination.total);
    setIsFetching(false);
    await updateSearchParams(newParams, true);
  };
  return (
    <>
      <Box sx={{ marginBottom: '-80px' }}>
        <BackgroundImage className="banner banner--smaller" image={image}>
          <Container p={4} sx={{ display: 'flex', alignItems: 'end' }}>
            <Grid columns={[1]}>
              <Box>
                <Themed.h1 sx={{ lineHeight: 1.2, marginBottom: 3 }}>
                  {pageData.title} {total}
                </Themed.h1>
              </Box>
            </Grid>
          </Container>
        </BackgroundImage>
      </Box>

      <Box sx={{ position: 'relative' }}>
        <Box
          bg="primaryPaleBg"
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '50%',
          }}
        />
        <Container px={4} sx={{ padding: ['0', '32px'] }}>
          <Container
            bg="white"
            sx={{
              padding: ['50px 32px', '50px'],
              borderRadius: '20px',
              boxShadow: '0px 10px 50px #0000001A',
              position: 'relative',
            }}
          >
            <Box sx={{ margin: 'auto' }}>
              <form onSubmit={submitFilters}>
                <FieldWithLabel
                  label={t('searchLabel')}
                  id="q"
                  value={q}
                  sx={{
                    maxWidth: ['100%', '100%'],
                    width: ['414px', '400px'],
                    marginBottom: '27px',
                  }}
                  className="field-dash-between"
                  onKeyUp={handleInputChange}
                  onChange={(e) => setQ(e.target.value)}
                />
                <Flex sx={{ gap: '15px', flexWrap: 'wrap' }}>
                  <Flex
                    sx={{
                      width: ['100%', 'auto'],
                      gap: '15px',
                    }}
                  >
                    <FieldWithLabel
                      label={t('priceFrom')}
                      sx={{
                        width: ['auto', 'auto', '100px', '110px'],
                      }}
                      value={priceFrom}
                      id="priceFrom"
                      onKeyUp={handleInputChange}
                      onChange={(e) => setPriceFrom(e.target.value)}
                    />

                    <FieldWithLabel
                      label={t('priceTo')}
                      value={priceTo}
                      id="priceTo"
                      sx={{
                        width: ['auto', 'auto', '110px', '110px'],
                      }}
                      className="field-dash-between"
                      onKeyUp={handleInputChange}
                      onChange={(e) => setPriceTo(e.target.value)}
                    />
                  </Flex>
                  <Flex
                    sx={{
                      width: ['100%', 'auto'],
                      gap: '15px',
                    }}
                  >
                    <FieldWithLabel
                      label={t('lessonDay')}
                      sx={{
                        width: ['auto', 'auto', '140px', '140px'],
                      }}
                      isDatepicker={true}
                    >
                      <DatePicker
                        locale={locale}
                        minDate={startOfDay(Date.now())}
                        selected={filters.startDateTime}
                        onChange={handleStartDateChange}
                      />
                    </FieldWithLabel>

                    <FieldWithLabel
                      sx={{
                        width: ['auto', 'auto', '120px', '120px'],
                      }}
                      className="field-dash-between"
                      isDatepicker={true}
                    >
                      <DatePicker
                        locale={locale}
                        minDate={startOfDay(Date.now())}
                        excludeDateIntervals={[]}
                        selected={filters.endDateTime}
                        onChange={handleEndDateChange}
                      />
                    </FieldWithLabel>
                  </Flex>
                  <Flex
                    sx={{
                      width: ['100%', 'auto'],
                      gap: '15px',
                    }}
                  ></Flex>

                  <FieldWithLabel
                    sx={{
                      minWidth: '150px',
                      maxWidth: ['414px', '200px'],
                      width: ['100%', '50%', 'auto'],
                      marginLeft: '0',
                      gap: '15px',
                    }}
                    label={t('sortBy')}
                    isSelect
                    onChange={handleSort}
                  >
                    {sortOptions.map(({ label }, index) =>
                      filters &&
                      filters.order === sortOptions[index].order &&
                      filters.orderDirection ===
                        sortOptions[index].orderDirection ? (
                        <option value={index} key={label} selected>
                          {label}
                        </option>
                      ) : (
                        <option value={index} key={label}>
                          {label}
                        </option>
                      )
                    )}
                  </FieldWithLabel>
                  <Flex
                    sx={{
                      width: ['auto'],
                      display: ['none', null, null, 'flex'],
                      gap: '15px',
                    }}
                  >
                    <Button
                      variant="empty"
                      sx={{
                        color: !isListMode ? '#707070' : '#ececec',
                      }}
                      onClick={() => {
                        setIsListMode(false);
                      }}
                    >
                      <GridViewIcon />
                    </Button>
                    <Button
                      variant="empty"
                      sx={{
                        color: isListMode ? '#707070' : '#ececec',
                      }}
                      onClick={() => {
                        setIsListMode(true);
                      }}
                    >
                      <ListViewIcon />
                    </Button>
                  </Flex>
                </Flex>
              </form>
            </Box>
          </Container>
        </Container>
      </Box>

      <Box bg="primaryPaleBg" pb={6}>
        <Container p={4} sx={{ padding: ['32px 0', '32px'] }}>
          <InfiniteScroll
            dataLength={results.length}
            next={loadMoreData}
            scrollThreshold={0.8}
            style={{ overflow: 'unset' }}
            hasMore={hasMore}
            loader={
              <Box py={4}>
                <Loader active inline="centered" />
              </Box>
            }
          >
            <Grid
              ref={resultsRef}
              gap="28px"
              columns={isListMode ? [1] : [1, 1, 2, 3]}
            >
              {results.map((teacher) => (
                <TeacherCard
                  teacher={teacher}
                  isListMode={isListMode}
                  key={teacher.id}
                />
              ))}
            </Grid>
          </InfiniteScroll>
          {!isFetching && results.length === 0 && (
            <Box py={5} sx={{ textAlign: 'center' }}>
              <SuitcaseIcon />
              <p sx={{ fontSize: 4, marginBottom: 0 }}>
                {t('teachersNotFound')}
              </p>
              <p sx={{ fontSize: 4, margin: 0 }}>
                {t('tryChangingYourSearchCriteria')}
              </p>
            </Box>
          )}
        </Container>
      </Box>
    </>
  );
};

export default subjectSearchPage;
